<template>
  <router-link class="project-feature loaded no-link" v-if="loaded" :to="'/project/' + urlPostFix">
    <article>
      <img :alt="`${title} thumbnail`" :src="thumbnailSrc" :srcset="thumbnailSrcset" class="pf-bg">
      <h1>{{ title }}</h1>
    </article>
  </router-link>
  <div class="project-feature loading-element" v-else></div>
</template>

<script>
export default {
  name: 'project-thumbnail',
  props: {
    id: { type: Number },
    title: { default: '' },
    loaded: { default: false, type: Boolean },
    thumbnails: {
      default: () => { return {}; },
      type: Object
    },
    urlPostFix: {
      type: String
    }
  },
  computed: {
    thumbnailSrc: function() {
      let keys = this.thumbnails === null ? [] : Object.keys(this.thumbnails);
      if (keys.length > 0) {
        return this.thumbnails[keys[keys.length - 1]];
      }
      return '';
    },
    thumbnailSrcset: function() {
      let keys = this.thumbnails === null ? [] : Object.keys(this.thumbnails);
      if (keys.length <= 0) {
        return '';
      }

      let result = '';
      keys.forEach((key) => {
        result += `${this.thumbnails[key]} ${key},`;
      });
      return result.slice(0, result.length - 1);
    }
  }
};
</script>


<style lang="scss">
  @import '../assets/scss/variables';
  // Parent object should have the class projects featured.
  .projects-featured {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;

    margin: ($spacer/2) (-$spacer/2);

    .project-feature {
      margin: $spacer/2;

      min-height: 250px;
      width: 100%;

      position: relative;
      overflow: hidden;

      font-size: $fontSizeLg;

      h1 {
        // Article tag requires a heading, but no need for increased font size.
        font-size: inherit;
      }

      &.loaded .pf-bg{
        background-color: rgba(200, 200, 200, .08);
      }

      &.loading-element {
        margin-bottom: calc(#{$spacer/2} + 1em);
      }

      &.failed {
        font-size: $h2FontSize;
        text-align: center;
      }

      .pf-bg {
        width: 100%;
        height: 250px;

        object-fit: cover;
      }

      .pf-link {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }

    @media screen and (min-width: $mediaNavigationMobile) {
      .project-feature {
        width: calc(50% - #{$spacer});
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ProjectThumbnail.vue